import { formatTimestampWithTimezone } from '../../../utils/formatTimestamp';

export function serializeSearchContact(contact) {
  return {
    contactId: contact.contactID,
    address: contact.address || contact.fullAddress || undefined,
    name: contact.name || undefined,
    email: contact.email || undefined,
    phone: contact.phone || contact.phoneNumber || contact.mobilePhone || undefined,
  };
}

export function serializeTransaction(transaction, timezone) {
  const formattedTimestamp = transaction.timestamp
    ? formatTimestampWithTimezone(transaction.timestamp, timezone, 'MMM D, YYYY')
    : undefined;
  return {
    transactionId: transaction.transactionID,
    contactId: transaction.contactID || undefined,
    donorName: transaction.dashboardDonorName || undefined,
    email: transaction.email || undefined,
    totalCharged: transaction.totalCharged,
    state: transaction.state,
    timestamp: transaction.timestamp,
    timestampFormatted: formattedTimestamp || undefined,
  };
}

function serializeDonationRecord(record, timezone) {
  if (!record) {
    return record;
  }

  const formattedTimestamp = record.timestamp
    ? formatTimestampWithTimezone(record.timestamp, timezone, 'MMM D, YYYY')
    : undefined;

  return {
    ...record,
    timestampFormatted: formattedTimestamp || undefined,
  };
}

export function serializeDonationSummary(summary, timezone) {
  if (!summary) {
    return null;
  }

  return {
    contactId: summary.contactId,
    donationCount: summary.donationCount,
    firstDonationAt: summary.firstDonationAt,
    firstDonationAtFormatted: summary.firstDonationAt
      ? formatTimestampWithTimezone(summary.firstDonationAt, timezone, 'MMM D, YYYY')
      : undefined,
    firstDonationAmount: summary.firstDonationAmount,
    firstDonationTransactionId: summary.firstDonationTransactionId,
    lastDonationAt: summary.lastDonationAt,
    lastDonationAtFormatted: summary.lastDonationAt
      ? formatTimestampWithTimezone(summary.lastDonationAt, timezone, 'MMM D, YYYY')
      : undefined,
    lastDonationAmount: summary.lastDonationAmount,
    lastDonationTransactionId: summary.lastDonationTransactionId,
    lifetimeAggregationAmount: summary.lifetimeAggregationAmount,
    lifetimeTotalCharged: summary.lifetimeTotalCharged,
    firstDonation: serializeDonationRecord(summary.firstDonation, timezone),
    lastDonation: serializeDonationRecord(summary.lastDonation, timezone),
  };
}

export function serializeSubscription(subscription) {
  return {
    subscriptionId: subscription.id,
    contactId: subscription.contactID || undefined,
    donorName: subscription.dashboardDonorName || undefined,
    email: subscription.email || undefined,
    totalCharged: subscription.totalCharged,
    status: subscription.subscriptionStatus,
    frequency: subscription.donationFrequency,
  };
}

export function serializeForm(form) {
  return {
    formId: form.elementID,
    name: form.formName,
    type: form.formType,
    active: form.active,
  };
}

export function serializeElement(element) {
  return {
    elementId: element.elementID,
    name: element.elementName,
    type: element.elementType,
    active: element.active,
  };
}
